import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "src/modules/notification/redux";
import adminRolesApi from "src/configs/apis/admin-roles";
import AdminRoletSelectPopoverComponent from "./adminRoleSelectPopover.component";
import { useAdminContext } from "../../../contexts/admin.context";
import AdminRoleSelectComponent from "./adminRoleSelect.component";

function AdminRoleSelectContainer({
  placeholder,
  selectedAdminRole,
  handleAdminRoleChange,
  fetchAllAdminRole = false,
}) {
  const dispatch = useDispatch();

  const [hasNextPage, setHasNextPage] = useState(false);
  const [totalFiltered, setTotalFiltered] = useState(0);
  const [isError, setIsError] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [adminRoleDropdown, setAdminRoleDropdown] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [filter, setFilter] = useState({
    length: fetchAllAdminRole ? -1 : 25,
    page: 0,
    search: "",
  });

  const getAdminRoleDropdown = async () => {
    setIsFetching(true);
    await adminRolesApi
      .getAdminRoleDropdown({
        length: filter.length,
        start: filter.page * filter.length,
        search: filter.search,
      })
      .then((res) => {
        setIsFetching(false);
        setHasNextPage(res.data.hasNextPage);
        setTotalFiltered(res.data.totalFiltered);
        setAdminRoleDropdown(res.data.data);
        return res.data;
      })
      .catch((error) => {
        setIsFetching(false);
        setIsError(true);
        return error;
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  useEffect(() => {
    getAdminRoleDropdown();
  }, [filter]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFetchMoreItems = () => {
    if (hasNextPage) {
      const newFilter = {
        ...filter,
        page: filter.page + 1,
      };
      setFilter(newFilter);
    }
  };

  const handleReload = () => {
    // dispatch(resetProductDropdown());
    setFilter({
      ...filter,
      page: 0,
      search: "",
    });
  };

  const handleSelectField = (field) => {
    handleAdminRoleChange(field);
    handleClose();
  };

  return (
    <>
      <AdminRoleSelectComponent
        open={open}
        handleClick={handleOpen}
        selectedAdminRole={selectedAdminRole}
        placeholder={placeholder}
      />
      <AdminRoletSelectPopoverComponent
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        isFetching={isFetching}
        isError={isError}
        adminRoleDropdown={adminRoleDropdown}
        totalFiltered={totalFiltered}
        hasNextPage={hasNextPage}
        handleFetchMoreItems={handleFetchMoreItems}
        handleSelectField={handleSelectField}
        handleReload={handleReload}
      />
    </>
  );
}

export default AdminRoleSelectContainer;
